import { Util } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
const useGetWishlistAriaLabel = (count) => {
  const intl = useIntl();
  const ariaLabel = count === 0 ? intl.getLabel("account.wishlist.button.empty.title") : Util.getCartTotalsTitle(
    count,
    intl,
    "account.wishlist.button.totalItems.singular",
    "account.wishlist.button.totalItems.plural"
  );
  return ariaLabel;
};
export {
  useGetWishlistAriaLabel
};
//# sourceMappingURL=use-get-wishlist-aria-label.js.map
